import React, { Component } from "react";
import { Spin, notification } from "antd";

import axiosGlobal from "../../axios-global";

class FormDataPdf extends Component {
  state = {
    loading: false,
    customError: null,
    data: [],
  };

  componentDidMount = () => {
    // console.log(this.props)
    this.fetch();
  };

  componentDidUpdate(prevProps) {
    if (this.props.participantId !== prevProps.participantId) {
      this.fetch();
    }
  }

  fetch = () => {
    this.setState({ loading: true });
    const params = {
      participantId: this.props.participantId,
      token: this.props.token
    };

    try {
      axiosGlobal().then((axios) => {
        axios.post("/psikogram/pdf", params).then((res) => {
          console.log(res.data.data)
          // console.log(this.props)
          if (!res.data.data.length) {
            this.setState({
              loading: false,
              customError: res.data.message,
            });
          } else {
            this.setState({
              loading: false,
              data: res.data.data,
              customError: null
            });
          }
        });
      });
    } catch (err) {
      console.log(err);
      this.setState({ loading: false, data: [] });
      this.openNotification("Selesaikan tes terlebih dahulu", false);
    }
  };

  openNotification = (msg, status) => {
    const args = {
      message: msg,
      duration: 5,
      className: status ? "notif-succes" : "notif-faild",
    };
    notification.open(args);
  };

  render() {
    let mainBody = null;
    if (this.state.loading) {
      mainBody = (
        <div>
          <Spin />
        </div>
      );
    } else if (this.state.customError) {
      mainBody = (
        <div>
          <h4>{this.state.customError}</h4>
        </div>
      );
    } else {
      mainBody = (
        <div>
          {/* {this.props.payment_type === "in-arrear" && !this.props.is_paid ? (
            <iframe
            ref={(el) => {
              this.componentRef = el;
            }}
            style={{ height: "70vh", width: "100%", filter: "blur(5px)", WebkitFilter: "blur(5px)", }}
            // #scrollbar=1&toolbar=0&statusbar=0
            src={`data:application/pdf;base64,${this.state.data}#scrollbar=1&toolbar=0&statusbar=0`}
            title={"Your Psikogram"}
            />
          ) : ( */}
            <iframe
            ref={(el) => {
              this.componentRef = el;
            }}
            style={{ height: "70vh", width: "100%" }}
            src={`data:application/pdf;base64,${this.state.data}`}
            title={"Your Psikogram"}
            ></iframe>
          {/* )} */}
        </div>
      );
    }
    return <React.Fragment>{mainBody}</React.Fragment>;
  }
}
export default FormDataPdf;
